import { FolderMarkerIcon } from './FolderMarkerIcon';

/**
 * author: Andrea Antonello
 * id 00FD0F50-240F-4654-9712-C219B0FF9A97
 * name folder-marker
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-marker.svg
 * tags
 * - Geographic Information System 
 * - Files / Folders 
 * - Navigation 
 */
export const FolderLocationIcon = FolderMarkerIcon;
export default FolderLocationIcon